const dynamicParameterFields = {
  required: "Este campo é obrigatório",
  notSupportedField: "Este tipo de campo não é suportado",
  parametersNotNecessary: "Parâmetros não são necessários para este workflow",
  autoFilled: "Preenchido da ferramenta",
  autoFilledFromIntegration: "Campo preenchido automaticamente a partir da ferramenta selecionada"
};

export default dynamicParameterFields;